export const GET_USER_LOCATION_PROFILE = 'GET_USER_LOCATION_PROFILE';
export const GET_USER_LOCATION_PROFILE_FAILED = 'GET_USER_LOCATION_PROFILE_FAILED';
export const EDIT_USER_LOCATION_PROFILE_FIELD_STARTING = 'EDIT_USER_LOCATION_PROFILE_FIELD_STARTING';
export const EDIT_USER_LOCATION_PROFILE_FIELD = 'EDIT_USER_LOCATION_PROFILE_FIELD';
export const CLEAR_STORES = 'CLEAR_STORES';
export const CLEAR_USER_LOCATION_STORE = 'CLEAR_USER_LOCATION_STORE';
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT_FROM_PROFILE';
export const REMOVE_PRODUCT_FAILED = 'REMOVE_PRODUCT_FAILED';
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const LOG_OUT = 'LOG_OUT';
export const PROFILE_IMAGE_CHANGED = 'PROFILE_IMAGE_CHANGED';
export const DELETE_COVER_IMAGE_FROM_LOCATION = 'DELETE_COVER_IMAGE_FROM_LOCATION';
export const IMPORTING_PROD = 'IMPORTING_PROD';
export const FINISHED_IMPORTING_PROD = '{profile}FINISHED_IMPORTING_PROD';



// WEBPACK FOOTER //
// ./src/app/stores/profile/location/location-constants.js